export default __webpack_public_path__ + "static/media/bg-main.6e2654e6.jpg";